"use strict"; // Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.

var _classCallCheck = require("/home/runner/work/learnr/learnr/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/learnr/learnr/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var coreutils_1 = require("@jupyterlab/coreutils");

var serverconnection_1 = require("../serverconnection");
/**
 * The url for the lab build service.
 */


var BUILD_SETTINGS_URL = 'lab/api/build';
/**
 * The build API service manager.
 */

var BuildManager = /*#__PURE__*/function () {
  /**
   * Create a new setting manager.
   */
  function BuildManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BuildManager);

    this.serverSettings = options.serverSettings || serverconnection_1.ServerConnection.makeSettings();
  }
  /**
   * Test whether the build service is available.
   */


  _createClass(BuildManager, [{
    key: "isAvailable",
    get: function get() {
      return coreutils_1.PageConfig.getOption('buildAvailable').toLowerCase() === 'true';
    }
    /**
     * Test whether to check build status automatically.
     */

  }, {
    key: "shouldCheck",
    get: function get() {
      return coreutils_1.PageConfig.getOption('buildCheck').toLowerCase() === 'true';
    }
    /**
     * Get whether the application should be built.
     */

  }, {
    key: "getStatus",
    value: function getStatus() {
      var base = this.serverSettings.baseUrl;
      var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
      var serverSettings = this.serverSettings;
      var promise = serverconnection_1.ServerConnection.makeRequest(url, {}, serverSettings);
      return promise.then(function (response) {
        if (response.status !== 200) {
          throw new serverconnection_1.ServerConnection.ResponseError(response);
        }

        return response.json();
      }).then(function (data) {
        if (typeof data.status !== 'string') {
          throw new Error('Invalid data');
        }

        if (typeof data.message !== 'string') {
          throw new Error('Invalid data');
        }

        return data;
      });
    }
    /**
     * Build the application.
     */

  }, {
    key: "build",
    value: function build() {
      var base = this.serverSettings.baseUrl;
      var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
      var serverSettings = this.serverSettings;
      var init = {
        method: 'POST'
      };
      var promise = serverconnection_1.ServerConnection.makeRequest(url, init, serverSettings);
      return promise.then(function (response) {
        if (response.status === 400) {
          throw new serverconnection_1.ServerConnection.ResponseError(response, 'Build aborted');
        }

        if (response.status !== 200) {
          var message = "Build failed with ".concat(response.status, ", please run 'jupyter lab build' on the server for full output");
          throw new serverconnection_1.ServerConnection.ResponseError(response, message);
        }
      });
    }
    /**
     * Cancel an active build.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      var base = this.serverSettings.baseUrl;
      var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
      var serverSettings = this.serverSettings;
      var init = {
        method: 'DELETE'
      };
      var promise = serverconnection_1.ServerConnection.makeRequest(url, init, serverSettings);
      return promise.then(function (response) {
        if (response.status !== 204) {
          throw new serverconnection_1.ServerConnection.ResponseError(response);
        }
      });
    }
  }]);

  return BuildManager;
}();

exports.BuildManager = BuildManager;